// extracted by mini-css-extract-plugin
var _1 = "EmbedContent-module__animatedBackground--I214e";
var _2 = "EmbedContent-module__container--FAckX";
var _3 = "EmbedContent-module__content--mLCkb";
var _4 = "EmbedContent-module__disableContentSelection--WaKbd";
var _5 = "EmbedContent-module__editable--yVRGj";
var _6 = "EmbedContent-module__footer--gno9Y";
var _7 = "EmbedContent-module__hasNativeFooter--KX2RC";
var _8 = "EmbedContent-module__type-google-doc--oZcdW";
var _9 = "EmbedContent-module__type-microsoft-office--qSWOb";
var _a = "EmbedContent-module__type-twitter--q_Dgx";
var _b = "EmbedContent-module__wrapper--xA51v";
export { _1 as "animatedBackground", _2 as "container", _3 as "content", _4 as "disableContentSelection", _5 as "editable", _6 as "footer", _7 as "hasNativeFooter", _8 as "type-google-doc", _9 as "type-microsoft-office", _a as "type-twitter", _b as "wrapper" }
